"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedType = void 0;
var FeedType;
(function (FeedType) {
    FeedType[FeedType["LIBRARY_ITEM_COMMENTS"] = 0] = "LIBRARY_ITEM_COMMENTS";
    FeedType[FeedType["LIBRARY_ITEM_CREATED"] = 1] = "LIBRARY_ITEM_CREATED";
    FeedType[FeedType["LIBRARY_ITEM_EPISODES_ADDED"] = 2] = "LIBRARY_ITEM_EPISODES_ADDED";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
